import { render, staticRenderFns } from "./overtime_detail.vue?vue&type=template&id=b1e45ba4&scoped=true"
import script from "./overtime_detail.vue?vue&type=script&lang=js"
export * from "./overtime_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e45ba4",
  null
  
)

export default component.exports